import { IS_YOUZHONG } from '../../oem';

export const INTVIEW_STATUS_INIT = 0;
export const INTVIEW_STATUS_VIDEO_BROADCAST = 1;
export const INTVIEW_STATUS_VIDEO_BROADCAST_REPLAY = 2;
export const INTVIEW_STATUS_AUDIO_BROADCAST = 3;
export const INTVIEW_STATUS_PREPARE = 4;
export const INTVIEW_STATUS_START = 5;
export const INTVIEW_STATUS_FOLLOWUP = 6;
export const INTVIEW_STATUS_FINISH = 7;

export const CARD_BACKGROUNDS = [
  'https://webcdn.fbmms.cn/assets/HgRR/I8FFT4Ld1JusJIQC_W1vI',
  'https://webcdn.fbmms.cn/assets/vThz/1zS1wxcxf3z7egIHCYBIU',
  'https://webcdn.fbmms.cn/assets/LLPK/3AfXIfHrFUeCo4sF0tzo1',
  'https://webcdn.fbmms.cn/assets/0MSc/nyqD508GuNDWZOQQ2WLkM',
  'https://webcdn.fbmms.cn/assets/VKxw/qP0b0333sVSwo4G2n-cOg',
  'https://webcdn.fbmms.cn/assets/BfWS/Ei7GIWHPDHIrV-bjNzFnH',
];

export const CARD_BACKGROUNDS_YOUZHONG = [
  'https://webcdn.fbmms.cn/assets/rkPs/pmWrrCtBQkZY1fLwT1bxX.png',
  'https://webcdn.fbmms.cn/assets/39D0/OYNbhrCObq-5kSCJ0P8U3.png',
  'https://webcdn.fbmms.cn/assets/TCxb/pl4-LUpRGm3nsqbVcYWAN.png',
  'https://webcdn.fbmms.cn/assets/ligc/LXIqovsOZO9HS6d9Dku1i.png',
  'https://webcdn.fbmms.cn/assets/ptpU/6EHQChKNIcA_mOnbTdZLg.png',
  'https://webcdn.fbmms.cn/assets/QtSU/7VyGg6Anr7UYgQX37JNK3.png',
  'https://webcdn.fbmms.cn/assets/9-eo/wtjNc4mYLEHWhxk1NnHgA.png',
  'https://webcdn.fbmms.cn/assets/3R3I/pKXdHT9RMT37Jj7u7W6BN.png',
  'https://webcdn.fbmms.cn/assets/of8u/sFybuUvGrA4AsdDLTXpyM.png',
  'https://webcdn.fbmms.cn/assets/iX7Q/EbZyT9dHk2nN1kyp1XnzE.png',
  'https://webcdn.fbmms.cn/assets/NBP0/1g4DN46dr63gToYv7H1Ep.png',
  'https://webcdn.fbmms.cn/assets/BAfo/EXOd52kS4kP0JCVOyDZ8t.png',
];

export function hashFunction(t, modulus = 6) {
  let hash = 0;
  if (t.length === 0) {
    return hash;
  }
  for (let i = 0; i < t.length; i++) {
    const char = t.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash % modulus); // Ensure index is within 0-8
}

export const getBackground = (positionToken) => {
  if (IS_YOUZHONG) {
    return CARD_BACKGROUNDS_YOUZHONG[hashFunction(positionToken, 12)];
  }
  return CARD_BACKGROUNDS[hashFunction(positionToken)];
};

export const canMobileLogin = () => {
  const mobileLoginOpen = localStorage.getItem('mobileLoginOpen');
  return mobileLoginOpen === '1' || mobileLoginOpen == null;
};

export const SETP_ACTION_MAP = {
  [INTVIEW_STATUS_INIT]: 'taking',
  [INTVIEW_STATUS_VIDEO_BROADCAST]: 'taking',
  [INTVIEW_STATUS_VIDEO_BROADCAST_REPLAY]: 'taking',
  [INTVIEW_STATUS_AUDIO_BROADCAST]: 'taking',
  [INTVIEW_STATUS_PREPARE]: 'idle',
  [INTVIEW_STATUS_START]: 'activated',
  [INTVIEW_STATUS_FOLLOWUP]: 'thinking',
  [INTVIEW_STATUS_FINISH]: 'idle',
};
